'use client';

import { animated, easings, useReducedMotion, useSpring } from '@react-spring/web';
import { IconChevronDownFilled } from '@zillow/constellation-icons/react/filled/icon-chevron-down-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Button } from '../button';
import { MenuRootContext } from './context/menu-root.context';
import type { MenuButtonPropsInterface } from './types/menu-button.types';

export const MenuButton = forwardRef<HTMLButtonElement, MenuButtonPropsInterface>(
  (props: MenuButtonPropsInterface, forwardedRef) => {
    const { children, css: cssProp, ...rest } = props;
    const { menu } = useContext(MenuRootContext);

    const reduceMotion = useReducedMotion();

    const animatedIconStyles = css({
      display: 'inline-flex',
    });

    const animatedIconProps = useSpring({
      rotate: menu.open ? 180 : 0,
      config: {
        easing: easings.easeInOutQuart,
        duration: reduceMotion ? 0 : 250,
      },
    });

    return (
      <Button.Root
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Menu.Button"
        tone="brand"
        emphasis="outlined"
        css={cssProp}
        {...rest}
      >
        <Button.Label>{children}</Button.Label>
        <animated.span className={cx('c11n', animatedIconStyles)} style={animatedIconProps}>
          <Button.Icon render={<IconChevronDownFilled />} />
        </animated.span>
      </Button.Root>
    );
  },
);

MenuButton.displayName = 'Menu.Button';
